import { cn } from "@/lib/utils";

const LEVELS = {
  verified_fact: { label: "Verified Fact", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  partner_confirmed: { label: "Partner Confirmed", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  public_source: { label: "Public Source", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  estimate: { label: "Estimate", cls: "bg-purple-50 text-purple-700 border-purple-200" },
  assumption: { label: "Assumption", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  needs_verification: { label: "Needs Verification", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export default function EvidenceBadge({ level = "assumption", className = "" }) {
  const info = LEVELS[level] || LEVELS.assumption;
  return (
    <span
      data-testid={`evidence-badge-${level}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider border rounded-full",
        info.cls, className
      )}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {info.label}
    </span>
  );
}

export const EVIDENCE_OPTIONS = Object.keys(LEVELS).map(k => ({ value: k, label: LEVELS[k].label }));
